import { cn } from '../lib/utils.js';

interface SkeletonProps {
  className?: string;
}

/**
 * Loading-state placeholder. Always rendered with `aria-hidden` — pair with a
 * separate live region (or `aria-busy` on the container) to announce loading
 * to assistive tech.
 */
export function Skeleton({ className }: SkeletonProps): JSX.Element {
  /* A SPAN DRAWN AS A BLOCK, not a div: a skeleton stands in for a VALUE, and
     values sit inside text — StatTile's figure is a <p>, and a <div> there is
     invalid HTML React warns about on every loading render. `block` keeps the
     box it always drew; a caller's own display class still wins (`cn` merges). */
  return (
    <span
      className={cn(
        'block animate-pulse rounded-xs bg-muted',
        className
      )}
      aria-hidden="true"
    />
  );
}

export function SkeletonRows({
  rows = 3,
  cols = 4,
}: {
  rows?: number;
  cols?: number;
}): JSX.Element {
  return (
    <div className="space-y-element p-component">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3">
          {Array.from({ length: cols }).map((__, c) => (
            <Skeleton key={c} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}
